@if (projectId) {
  @if (isListView) {
    <ul class="nav nav-tabs mb-3">
      @for (tab of financeTabs; track tab.id) {
        <li class="nav-item">
          <a class="nav-link" [class.active]="view === tab.id" href="javascript:void(0);"
            (click)="selectTab(tab.id)">{{ tab.title }}</a>
        </li>
      }
    </ul>
  }

  @switch (view) {
    @case ('income') {
      <projects-finance-income [projectId]="projectIdNumber" />
    }
    @case ('analysis') {
      <projects-finance-analysis [projectId]="projectIdNumber" />
    }
    @case ('instalment-edit') {
      <projects-finance-instalment-form [projectId]="projectIdNumber" [projectInvoiceId]="entityId" />
    }
    @case ('testing-cost-form') {
      <projects-finance-testing-cost-form [projectId]="projectIdNumber" [projectFinanceCostId]="entityId" />
    }
    @case ('other-cost-form') {
      <projects-finance-other-cost-form [projectId]="projectIdNumber" [projectFinanceOtherCostId]="entityId" />
    }
  }
}
